import {useState} from 'react';
import {ShareInTeamBarState} from '@Components/share-in-team-toggle-bar/share-in-team-toggle-bar.types';
import {GA4EventName, GA4EventParamName} from '@Libraries/ga-events';
import {openErrorModal} from '@Modals/error-modal';

interface ShareDesignInTeamCommonProps {
  isShareInTeamLoading: boolean;
  sharedInTeamState: ShareInTeamBarState;
  setSharedInTeamState: (barState: ShareInTeamBarState) => void;
  onShareTeamToggle: (barState: ShareInTeamBarState) => Promise<void>;
}

export const useShareDesignInTeam = (
  itemHashedId: string,
  onToggleSuccess?: (barState: ShareInTeamBarState) => void,
  initialState: ShareInTeamBarState = ShareInTeamBarState.INACTIVE
): ShareDesignInTeamCommonProps => {
  const [isShareInTeamLoading, setIsShareInTeamLoading] = useState(false);
  const [sharedInTeamState, setSharedInTeamState] = useState<ShareInTeamBarState>(initialState);
  const isPosterMaker = window.PMW.isReactPosterMaker();

  const onShareTeamToggle = async (barState: ShareInTeamBarState): Promise<void> => {
    setIsShareInTeamLoading(true);
    if (barState === ShareInTeamBarState.ACTIVE) {
      if (isPosterMaker) {
        window.PMW.gtm.trackGA4CustomEvent(GA4EventName.COLLABORATION_DESIGN_SHAREINTEAM, {[GA4EventParamName.SOURCE]: 'Editor'});
      } else {
        window.PMW.gtm.trackGA4CustomEvent(GA4EventName.COLLABORATION_DESIGN_SHAREINTEAM, {[GA4EventParamName.SOURCE]: 'Share dialog'});
      }
    }

    await window.PMW.writeLocal('posters/toggleDesignTeamShare', {
      hashedId: itemHashedId,
      isCurrentlyShared: !!ShareInTeamBarState.ACTIVE,
    })
      .then(() => {
        setSharedInTeamState(barState);
        if (onToggleSuccess) {
          onToggleSuccess(barState);
        }
      })
      .catch(() => {
        openErrorModal();
      })
      .finally(() => {
        setIsShareInTeamLoading(false);
      });
  };

  return {
    isShareInTeamLoading,
    sharedInTeamState,
    setSharedInTeamState,
    onShareTeamToggle,
  };
};
